import { render, staticRenderFns } from "./ConsultationsListPage.vue?vue&type=template&id=908c28e0&"
import script from "./ConsultationsListPage.vue?vue&type=script&lang=ts&"
export * from "./ConsultationsListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports